"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedKeyboardKeys = exports.getNextCell = exports.getRepeaterCells = void 0;
var getRepeaterCells_1 = require("./getRepeaterCells");
Object.defineProperty(exports, "getRepeaterCells", { enumerable: true, get: function () { return getRepeaterCells_1.getRepeaterCells; } });
var getNextCell_1 = require("./getNextCell");
Object.defineProperty(exports, "getNextCell", { enumerable: true, get: function () { return getNextCell_1.getNextCell; } });
exports.supportedKeyboardKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
//# sourceMappingURL=index.js.map